import React, { FC } from "react";
import { IconButton as MuiIconButton, IconButtonProps } from "@mui/material";

const IconButton: FC<IconButtonProps> = (props) => <MuiIconButton {...props} />;

export default IconButton;
